import { combineReducers } from 'redux';

import constants from './constants';

const rootReducer = combineReducers({
	constants,
});
  
export default rootReducer;
